import DiffMatchPatch from 'diff-match-patch';

const dmp = new DiffMatchPatch()

export default function getRepetitionRate(textA, textB) {
  var result = dmp.diff_main(textA, textB)
  dmp.diff_cleanupSemantic(result)
  var base = 0,
    comparison = 0,
    len = result.length,
    i = 0
  for (; i < len; i++) {
    var _r = result[i]
    var textLen = _r[1].length
    if (_r[0] === 0) {
      comparison += textLen
    }
    base += textLen
  }
  var rate = (comparison / base * 100).toFixed(0)
  return rate
}
